export const lessonDiaryConstants = {
  GETALL_REQUEST: 'LESSON_DIARY_GETALL_REQUEST',
  GETALL_SUCCESS: 'LESSON_DIARY_GETALL_SUCCESS',
  GETALL_FAILURE: 'LESSON_DIARY_GETALL_FAILURE',

  CREATE_REQUEST: 'LESSON_DIARY_CREATE_REQUEST',
  CREATE_SUCCESS: 'LESSON_DIARY_CREATE_SUCCESS',
  CREATE_FAILURE: 'LESSON_DIARY_CREATE_FAILURE',

  UPDATE_REQUEST: 'LESSON_DIARY_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'LESSON_DIARY_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'LESSON_DIARY_UPDATE_FAILURE',

  DELETE_REQUEST: 'LESSON_DIARY_DELETE_REQUEST',
  DELETE_SUCCESS: 'LESSON_DIARY_DELETE_SUCCESS',
  DELETE_FAILURE: 'LESSON_DIARY_DELETE_FAILURE',
};
